import { createContext, useId } from "react"

export const DragOriginContext = createContext<string | undefined>(undefined)

export function DragOriginContextProvider({
  origin,
  children
}: {
  origin?: string
  children: React.ReactNode
}) {
  const id = useId()
  return (
    <DragOriginContext.Provider value={origin || id}>
      {children}
    </DragOriginContext.Provider>
  )
}
